import React from 'react';
import { CentralDialogButton, BaseDialogProps } from '../../types';
import CentralDialog from '../CentralDialog/CentralDialog';

export interface CentralModalProps extends BaseDialogProps {
  body?: string;
  btnLeftText?: string;
  btnRightText: string;
  onClickBtnLeft?: (e: React.MouseEvent<HTMLButtonElement>) => void;
  onClickBtnRight: (e: React.MouseEvent<HTMLButtonElement>) => void;
  btnLeftDisabled?: boolean;
  btnRightDisabled?: boolean;
}

/*
 * Dialog which allow show text as dialog body
 */
const CentralModal: React.FC<CentralModalProps> = ({
  btnLeftText,
  btnRightText,
  onClickBtnLeft,
  onClickBtnRight,
  btnLeftDisabled,
  btnRightDisabled,
  ...props
}) => {
  const buttons: CentralDialogButton[] = [
    {
      text: btnRightText,
      onClick: onClickBtnRight,
      disabled: btnRightDisabled,
    },
  ];

  if (btnLeftText && onClickBtnLeft) {
    buttons.unshift({
      text: btnLeftText,
      onClick: onClickBtnLeft,
      disabled: btnLeftDisabled,
      variant: 'text',
    });
  }

  return <CentralDialog buttons={buttons} {...props} />;
};

export default CentralModal;
